import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useThemeStore } from '../../stores/themeStore';
import { cn } from '../../utils/cn';

interface Props {
  className?: string;
}

export function ThemeToggle({ className }: Props) {
  const { t } = useTranslation();
  const resolved = useThemeStore((s) => s.resolved);
  const toggle = useThemeStore((s) => s.toggle);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={resolved === 'dark' ? t('ui.themeToLight') : t('ui.themeToDark')}
      className={cn(
        'inline-flex items-center justify-center h-9 w-9 rounded-md',
        'border border-border bg-background',
        'hover:bg-accent hover:text-accent-foreground',
        'transition-colors',
        className
      )}
    >
      {resolved === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
